import type { User as DBUser } from '@/lib/types/database'

/**
 * APIレスポンスが有効なユーザープロファイルかを検証する型ガード。
 * `profile as DBUser` の unsafe キャストを置き換えるために使用する。
 */
export function isValidUserProfile(data: unknown): data is DBUser {
  if (!data || typeof data !== 'object') return false
  const obj = data as Record<string, unknown>
  return typeof obj.id === 'string' && obj.id.length > 0 &&
         typeof obj.email === 'string' && obj.email.length > 0 &&
         typeof obj.name === 'string'
}
